import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { mediaObjectRootStyles } from './styles/media-object-root.styles';
import type { MediaObjectRootPropsInterface } from './types/media-object-root.types';

/**
 * @since 10.0.0
 */
export const MediaObjectRoot = forwardRef<HTMLDivElement, MediaObjectRootPropsInterface>(
  (props: MediaObjectRootPropsInterface, forwardedRef) => {
    const { asChild = false, className, css: cssProp, ...rest } = props;
    const styles = css(mediaObjectRootStyles, cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="MediaObject.Root"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_media-object__root', styles, className)}
        {...rest}
      />
    );
  },
);

MediaObjectRoot.displayName = 'MediaObject.Root';
